import { DatePicker as AntDatePicker } from 'antd';
import type { RangePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';

import { useDateFormat } from '@frontend/utils';

import type {
  DateRangeRelationFilterValue,
  DateRangeValue,
  ExcludableDateRelation,
} from './types/';

const AntRangePicker = AntDatePicker.RangePicker;

type DateRangeInputValue = Parameters<
  Required<RangePickerProps>['onChange']
>[0];

export type DateRangeInputProps<
  ExcludedRelations extends ExcludableDateRelation,
> = {
  relationFilterValue: DateRangeRelationFilterValue<ExcludedRelations>;
  onChange: (newDateRange: DateRangeValue) => void;
};

const DateRangeInput = <ExcludedRelations extends ExcludableDateRelation>({
  relationFilterValue,
  onChange,
}: DateRangeInputProps<ExcludedRelations>) => {
  const { dateTimeFormat } = useDateFormat();
  return (
    <AntRangePicker
      value={
        relationFilterValue.startDate
          ? [relationFilterValue.startDate, relationFilterValue.endDate]
          : null
      }
      onChange={(selectedDateRange: DateRangeInputValue) => {
        const newDateRangeValue: DateRangeValue =
          selectedDateRange?.[0] && selectedDateRange?.[1]
            ? {
                startDate: selectedDateRange[0],
                endDate: selectedDateRange[1],
              }
            : { startDate: null, endDate: null };

        onChange(newDateRangeValue);
      }}
      showTime={{
        defaultValue: [moment('0:00:00', 'hh:mm'), moment('23:59:00', 'hh:mm')],
        format: 'hh:mm',
        use12Hours: true,
      }}
      style={{
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      }}
      format={dateTimeFormat}
      popupStyle={{ zIndex: 1400 }}
    />
  );
};

export default DateRangeInput;
